import {
  AsyncGridColumns,
  ColumnChipList,
  ColumnLink,
} from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.designation',
    field: 'name',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => (
      <ColumnLink to={`${row.id}/details`}>{row.name}</ColumnLink>
    ),
  },
  {
    headerName: 'column.phone number',
    field: 'phoneNumber',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.dispatcher',
    field: 'dispatchers',
    sortable: false,
    flex: 1,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
  {
    headerName: 'column.controller',
    field: 'controllers',
    sortable: false,
    flex: 1,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
  {
    headerName: 'column.medic',
    field: 'doctors',
    flex: 1,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
]
